import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';

import * as penalizacionesActions from 'modules/penalizaciones/action';
import { pickAColor } from 'core/generalFunctions';

moment.locale('es');

@connect((store) => ({
  pasajero: store.getIn(['reservas', 'pasajero']),
  penalizacionesUsuario: store.getIn(['penalizaciones', 'penalizacionesUsuario']),
  showListaPenalizaciones: store.getIn(['penalizaciones', 'showListaPenalizaciones']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  componentWillUnmount = () => {
    this.props.dispatch(penalizacionesActions.clear('all'));
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.penalizacionesUsuario) {
      if (prevProps.penalizacionesUsuario.size !== 0 && this.props.penalizacionesUsuario.size == 0)
        this.props.dispatch(this.props.dispatch(penalizacionesActions.setState({ showListaPenalizaciones: false })));
    }
  };
  solucionar = (penalizacionId, pago) => this.props.dispatch(penalizacionesActions.solucionar(penalizacionId, pago, true));
  render() {
    const { showListaPenalizaciones, pasajero, penalizacionesUsuario, loading, handleSubmit } = this.props;
    let nombrePasajero = pasajero.get('nombre') ? pasajero.get('nombre') + ' ' + pasajero.get('apellido') : 'pasajero';
    return (
      <MaterialUI.Dialog
        title={`Penalizaciones ${nombrePasajero} `}
        modal={false}
        autoScrollBodyContent={true}
        open={showListaPenalizaciones}
        onRequestClose={() => this.props.dispatch(penalizacionesActions.setState({ showListaPenalizaciones: false }))}
      >
        <MaterialUI.List className="noPadding dividerList">
          {penalizacionesUsuario.map((penalizacion) => {
            const minutos = penalizacion.get('minutosPreviosComienzoViaje');
            let text;
            if (minutos <= 60 && minutos >= -60) text = Math.abs(minutos) + ' minutos';
            else text = Math.round(Math.abs(minutos / 60) * 10) / 10 + ' horas';
            return (
              <MaterialUI.ListItem
                key={penalizacion.get('id')}
                disabled
                primaryText={
                  <Row>
                    <Col md="3">
                      <b>Costo:</b> ${penalizacion.get('costo')}
                    </Col>
                    <Col md="4">
                      Cancelo {text} {minutos < 0 ? 'antes' : 'despues'}
                    </Col>
                  </Row>
                }
                rightIconButton={
                  <Row>
                    <MaterialUI.FlatButton
                      icon={<FontAwesome className="iconBar yellow" name="trash" />}
                      onClick={() => this.solucionar(penalizacion.get('id'))}
                      className="listIcon"
                      label="Solucionado"
                      disabled={loading}
                    />
                    <MaterialUI.FlatButton
                      icon={<FontAwesome className="iconBar green" name="usd" />}
                      onClick={() => this.solucionar(penalizacion.get('id'), true)}
                      className="listIcon"
                      label="Pagado"
                      disabled={loading}
                    />
                  </Row>
                }
              />
            );
          })}
          {typeof handleSubmit == 'function' && <MaterialUI.RaisedButton className="fullWidthComponent noPadding m-tb-20" label="GUARDAR DE TODOS MODOS" onClick={handleSubmit()} disabled={loading} />}
        </MaterialUI.List>
      </MaterialUI.Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/penalizaciones/components/penalizacionesUsuario.js